export type LanguageState = AppLanguage;

export enum AppLanguage {
  English = 'en',
  German = 'de',
  Spanish = 'es'
}
